<app-card *ngIf="isLoading|async; else bodyTpl" [cardHeaderTitle]="'Alamat Pengiriman'" [titleInBody]="true">
  <ng-container cardBody>
    <app-section-loader />
  </ng-container>
</app-card>

<ng-template #bodyTpl>
  <ng-container [ngTemplateOutlet]="!!bodyDeliveryGroup.length ? addressList : emptyState"></ng-container>
</ng-template>

<ng-template #addressList>
  <ng-container *ngFor="let item of bodyDeliveryGroup">
    <app-card-tab-section [data]="item" [isAddressCard]="true" />
  </ng-container>
</ng-template>
<ng-template #emptyState>
  <app-card-empty text="Belum terdapat data alamat pengiriman." icon="{{ STRING_CONSTANTS.ICON.IC_LOCATION_NONE }}"/>
</ng-template>
